import React from 'react';

interface ProgressBarProps {
  progress: number;
  statusText: string;
  statusRevealing: boolean;
  visible: boolean;
  exiting: boolean;
  showDot?: boolean;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  statusText,
  statusRevealing,
  visible,
  exiting,
  showDot,
}) => {
  if (!visible) return null;

  const revealClass = statusRevealing ? 'reveal-in' : '';

  return (
    <div className={`ms-progress-section${exiting ? ' exiting' : ''}`}>
      <div className="ms-status-labels" style={{ marginBottom: '8px' }}>
        <div className="ms-status-left">
          <div className="ms-status-title">STATUS</div>
          <div className="ms-status-text">
            {showDot && <span className="ms-status-dot" />}
            <span className={`ms-status-text-inner ${revealClass}`}>
              {statusText}
            </span>
          </div>
        </div>
        <div className="ms-status-right">
          <div className="ms-percentage">{Math.round(progress)}%</div>
        </div>
      </div>
      <div className="ms-progress-track">
        <div
          className="ms-progress-fill"
          style={{ width: `${Math.round(progress)}%` }}
        />
      </div>
    </div>
  );
};
